import { Component } from 'vue-property-decorator';
import IssueItemBaseMixin from '@/components/ViewComponent/Issue/IssueItem/issue-item-base.mixin';
import { mapActions } from 'vuex';

@Component<IssueItemMixin>({
  methods: {
    ...mapActions('staff', ['fetchCurrentStaff']),
  },
})
export default class IssueItemMixin extends IssueItemBaseMixin {
  fetchCurrentStaff!: () => Promise<void>;

  get isShowFooter() {
    return (
      this.issue.staffId === this.currentStaff.id &&
      this.issue.supporters &&
      this.issue.supporters.length > 0
    );
  }
  get isShowItem() {
    return Number(this.issue.unreadNotify) > 0;
  }
}
